import { ServiceState } from './index';
import { ActionTree } from 'vuex';
import { IStore } from "@store/index";
import { AxiosError, AxiosResponse } from "axios";
import { fetchResponse } from "@store/services/fetchCheckoutData";
import CheckoutItem from "@store/checkout/interfaces/checkoutItem";
import ServiceItem from "@store/checkout/interfaces/serviceItem";

export default {
    async getAvailableServices({ commit, dispatch, rootState }) {
        await fetchResponse(
            rootState.checkout.apiEndpoint,
            'GetAvailableServices',
            rootState.checkout.checkoutSettings.trip.id,
            rootState.checkout.checkoutSummary.appointmentId,
            rootState.checkout.apiToken,
            rootState.checkout.checkoutSettings.sessionId,
            rootState.checkout.checkoutSummary.fare,
            rootState.checkout.checkoutSettings.locale
        )
            .then((response: AxiosResponse) => {
                commit('setAvailableServices', response.data);
                dispatch('restoreSelectedServices');
            })
            .catch((e: AxiosError) => {
                const errorStatus = e.response ? e.response.status : 'none';
                const message = `Error in getAvailableServices | Error code: 1642576805670 | HTTP status: ${errorStatus} | ${e.message}`;

                dispatch('openErrorOverlay');

                throw Error(message);
            });
    },
    async increaseServiceAmount({ commit, dispatch }, { service, serviceType }) {
        commit('increaseServiceAmount', service);
        commit('addSelectedServices', { service, serviceType });

        await dispatch('updatePriceSummary');
    },
    async decreaseServiceAmount({ commit, dispatch }, { service, serviceType }) {
        commit('decreaseServiceAmount', service);
        commit('reduceSelectedServices', { service, serviceType });

        await dispatch('updatePriceSummary');
    },
    restoreSelectedServices ({ state, commit, dispatch, rootState }) {
        if (rootState.checkout.checkoutSettings.restoreId === '') {
            return;
        }

        rootState.checkout.checkoutSummary.services.forEach((service: CheckoutItem) => {
            Object.entries(state.availableServices).forEach(([serviceType, availableServices]) => {
                const selectedService: ServiceItem | undefined = availableServices.find((serviceItem: ServiceItem) => serviceItem.id === service.id);
                if (!selectedService) {
                    return;
                }

                commit('restoreSelectedServices', { service: selectedService, serviceType, amount: service.amount });
            });
        });

        dispatch('funnel/addSelectedToCheckoutFunnel', { type: 'services', picked: state.selectedServices }, { root: true });
    },

} as ActionTree<ServiceState, IStore>
